module.exports = __webpack_public_path__ + "system/img/personal-logo.67e0d24f.png";